import CreditNotesDataGrid from "./CreditNotesDataGrid";
import { Flex, Button } from "@aws-amplify/ui-react";
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  return (
    <Flex margin="0 auto" direction="column" gap="1rem">
      <Flex direction="column" alignItems="flex-start">
        <Button variation="primary" onClick={() => navigate("/create-credit-note")}>
          Create credit note
        </Button>
        <Flex direction="column" style={{ width: '100%' }}>
          <CreditNotesDataGrid />
        </Flex>
      </Flex>
    </Flex>
  );
}
